import { Link } from 'react-router'
import { hasViewAssortmentPermission, hasWriteInstallationPermission } from '../../../lib/Permission'
import React from 'react'
import { FileType, InstallationOverview } from '../../../domain/DTO'
import { AssortmentStatusCell } from '../../../components/AssortmentStatusCell'

type InstallationOverviewRowProps = {
  installation: InstallationOverview
}

export const InstallationOverviewRow = ({ installation }: InstallationOverviewRowProps) => {
  const enabledAssortmentStatuses = [
    { type: FileType.SHAPE, status: installation.shapeStatus },
    { type: FileType.BARCODE, status: installation.barcodeStatus },
    { type: FileType.CRATE, status: installation.crateStatus },
    { type: FileType.LOCAL_CRATE, status: installation.localCrateStatus },
    { type: FileType.ARTIKELDATEN, status: installation.artikeldatenStatus },
  ].filter((item) => item.status.enabledForCommonAssortment)

  const createCommonAssortmentLink = () => {
    if (!installation.commonAssortmentId) {
      return 'Not Assigned'
    }

    if (hasViewAssortmentPermission() || hasWriteInstallationPermission()) {
      return (
        <Link to={`/common-assortment/${installation.commonAssortmentId}`} className="link">
          {installation.commonAssortmentName}
        </Link>
      )
    } else {
      return installation.commonAssortmentName
    }
  }

  const createInstallationLink = () => {
    return installation.commonAssortmentId ? (
      <Link to={`/installation/${installation.installationId}`} className="link">
        {installation.serialNumber}
      </Link>
    ) : (
      <p>{installation.serialNumber}</p>
    )
  }

  return (
    <tr key={installation.installationId} className="even:bg-grey-light hover:bg-fog">
      <td>{createInstallationLink()}</td>
      <td>{createCommonAssortmentLink()}</td>
      <td>
        {enabledAssortmentStatuses.length > 0 ? (
          <AssortmentStatusCell assortmentStatuses={enabledAssortmentStatuses} />
        ) : (
          'N/A'
        )}
      </td>
      <td>{installation.chainName ?? installation.subChainName}</td>
      <td>{`${installation.locationName} [${installation.country}${installation.region ? ', ' + installation.region : ''}]`}</td>
    </tr>
  )
}
